
(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxWorkstationAddNetworks(
    NetworkListService, $timeout, $http, $q, $filter, toastr, NetworkListPOSTPaging, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        tenant: "=resource",
        callback: '&callback'
      },
      templateUrl: 'app/components/workstationProperties/workstationSettings/workstationAddNetworks/workstationAddNetworks.template.html',
      link: function(scope) {

        scope.me = $rootScope.currentUser;
        scope.networkListPaging = new NetworkListPOSTPaging();

        scope.networkList = [];
        scope.noItemSelected = true;
        var scrollEnd = null;
        var containerHeight = null;
        var customKeyBinding = false;
        scope.searchString = '';
        var embed = '&embed=site';

        (function() {
          customKeyBinding = true;
          prepareListItems();
          getFirstPage();
        })();

        function prepareListItems () {
          var networks = scope.context.workstation.info._embedded.networks;
          angular.forEach(networks, function (network) {
            network.options = {};
            network.options.isSelected = false;
          })

          scope.networkAttached = networks
        }

        function setExcludes () {
          var excludes = [];

          angular.forEach(scope.context.workstation.info._embedded.networks, function (network) {
            excludes.push(network._links.self.href);
          })

          return excludes;
        }


        function getFirstPage() {
          scope.selectedNetworks = [];
          scope.unselectedNetworks = [];
          scope.networkListPaging.pagingCriteria.page = 0;
          scope.networkListPaging.pagingCriteria.excludeNetworkIds = scope.context.workstation.info._embedded.networks ? setExcludes() : null;
          scope.loadingPage = true;
          scope.networkList = [];

          NetworkListService.getNetworkListPagedByPost(scope.networkListPaging, embed).then(function (response) {
            window.scrollTo(0,0);
            scope.totalPages = response.page.totalPages;
            scope.networkList = response.list;
            scope.loadingPage = false;
          }).catch(function(error){});
        }

        // ADD THROTTLE TO THIS
        scope.textSearch = function () {
          scope.networkListPaging.pagingCriteria.match = scope.searchString;
          getFirstPage();
        }


        function getNextPage () {
          if (!scope.loadingPage && scope.totalPages > scope.networkListPaging.pagingCriteria.page + 1) {
            scope.loadingPage = true;
            scope.networkListPaging.pagingCriteria.page += 1;
            NetworkListService.getNetworkListPagedByPost(scope.networkListPaging, embed).then(function(response){
              if (response.list) {
                scope.networkList = scope.networkList.concat(response.list);
              }
              scope.loadingPage = false;
            }).catch(function(error){});
          }
        }


        angular.element('.pagination-content').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loadingPage && scope.totalPages > scope.networkListPaging.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.$on('$destroy', function() {
          angular.element('.pagination-content').off('scroll');
          customKeyBinding = false;
        });

        document.onkeydown = function(evt) {
          evt = evt || window.event;
          if (customKeyBinding){
            switch (evt.keyCode) {
              case 38:
                evt.preventDefault();
                if (document.activeElement.previousElementSibling) {
                  document.activeElement.previousElementSibling.focus();
                }
              break;
              case 40:
                evt.preventDefault();
                if (document.activeElement.nextElementSibling) {
                  document.activeElement.nextElementSibling.focus();
                }
              break;
            }
          }
        };

        scope.toggleSelectGroup = function (event, group) {
          event.stopPropagation()
          event.preventDefault()
          if (!group.options.isSelected) {
            group.options.isSelected = true
            scope.selectedNetworks.push(group);
          } else {
            group.options.isSelected = false
            scope.deselectGroup(event, group);
          }

          if (scope.selectedNetworks.length < 1) {
            scope.noItemSelected = true;
          } else {
            scope.noItemSelected = false;
          }
        }

        scope.toggleUnselectGroup = function (event, group) {
          event.stopPropagation()
          event.preventDefault()

          if (!group.options.isSelected) {
            group.options.isSelected = true
            scope.unselectedNetworks.push(group);
          } else {
            group.options.isSelected = false
            scope.deselectGroup(event, group);
          }

          if (scope.unselectedNetworks.length < 1) {
            scope.noItemSelected = true;
          } else {
            scope.noItemSelected = false;
          }
        }

        scope.deselectGroup =  function (event, group) {
          if (group.info) {
            for (var i = 0; i < scope.selectedNetworks.length; i++) {
              if (group.info._links.self.href === scope.selectedNetworks[i].info._links.self.href) {
                scope.selectedNetworks.splice(i, 1);
              }
            }
          } else {
            for (var i = 0; i < scope.unselectedNetworks.length; i++) {
              if (group._links.self.href === scope.unselectedNetworks[i]._links.self.href) {
                scope.unselectedNetworks.splice(i, 1);
              }
            }
          }

        }

        scope.closePopup = function () {
          scope.callback();
        }

        scope.saveChanges = function () {
          addNetworks();
        }

        function addNetworks () {
          var networksIdList = [];
          angular.forEach(scope.selectedNetworks, function (network) {
            networksIdList.push(network.info._links.self.href);
          })

          var url = scope.context.workstation.info._links["px:addZeroTrustNetworks"].href;
          $http.post(url, networksIdList).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'))
          }).catch(function(error){
            toastr.error($filter('translate')('ERROR'))
          });
          scope.callback();
        }



        ////////////////////////////////////////////
        ////////////////////////////////////////////
        // TOOLTIP STUFF
        ////////////////////////////////////////////
        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          var offsetLeft  =  angular.element('.context-content-container')[0].offsetLeft;
          var offsetTop  =  angular.element('.context-content-container')[0].offsetTop;
          if (showTip) {
            position.startX = position.startX - offsetLeft;
            position.startY = position.startY - offsetTop;
            switch(tooltipScope) {
              case 'networkTooltip':
                networkTooltip(position, context);
              break;
            }
          } else {
            scope.clearTooltip();
          }
        }

        function networkTooltip (position, context) {
          scope.clearTooltip();
          scope.tooltipContent = {
            title: context.info.name,
            type: 'networkAllDetails',
            network: context,
          }
          scope.tooltipObject = {
            position: {left: position.startX - 15, top: position.startY + 20},
            contextMenu: true
          }
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        }


      }
    };
  }

  pxWorkstationAddNetworks.$inject = [
    'NetworkListService', '$timeout', '$http', '$q', '$filter', 'toastr', 'NetworkListPOSTPaging', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxWorkstationAddNetworks', pxWorkstationAddNetworks);

})();
